import { render, staticRenderFns } from "./CandleSad.vue?vue&type=template&id=60fa7b06&scoped=true&"
var script = {}
import style0 from "./CandleSad.vue?vue&type=style&index=0&id=60fa7b06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fa7b06",
  null
  
)

export default component.exports